/**
 * バンドルミックスマッチ設定画面　プロモーション商品登録VOクラス
 */
export class KYMW1308PromotionGoodsRegistModel {

  // Ｐコード
  public pCode: string = <string>'';

  // 生協コード
  public coopCode: string = <string>'';

  // 成立数量
  public approvedNum: string = <string>'';

  // 成立価格
  public approvedPrice: string = <string>'';

  // わくわくポイント
  public wakuwakuPoint: string = <string>'';

}
